<template>
  <div class="contact-page">
    <div class="hero-gradient-overlay"></div>

    <v-container class="main-section py-16">
      <div class="content-wrapper">
        <div class="contact-hero mb-12 animate-fade-in">
          <div class="hero-badge mb-4">
            <v-icon small color="#f46523" class="mr-2">mdi-email</v-icon>
            <span>Get In Touch</span>
          </div>

          <h1 class="contact-title mb-4">Contact Oh Yes World</h1>

          <p class="contact-description">
            Have questions or need assistance? We're here to help! Fill out the
            form below and our team will get back to you as soon as possible.
          </p>
        </div>

        <v-row>
          <!-- Contact Form -->
          <v-col cols="12" md="7">
            <v-card class="contact-form-card animate-slide-up" elevation="0">
              <h2 class="form-title mb-6">Send us a Message</h2>

              <v-form ref="form" v-model="valid">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formData.fullName"
                      placeholder="Full name"
                      :rules="nameRules"
                      solo
                      flat
                      color="#f46523"
                      class="simple-input"
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="formData.email"
                      placeholder="email@domain.com"
                      :rules="emailRules"
                      solo
                      flat
                      color="#f46523"
                      class="simple-input"
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="formData.phone"
                      placeholder="Phone"
                      :rules="phoneRules"
                      solo
                      flat
                      color="#f46523"
                      class="simple-input"
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="formData.company"
                      placeholder="Company name"
                      solo
                      flat
                      color="#f46523"
                      class="simple-input"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-select
                      v-model="formData.subject"
                      :items="subjects"
                      placeholder="It's about..."
                      :rules="requiredRules"
                      solo
                      flat
                      color="#f46523"
                      item-color="#f46523"
                      class="simple-input"
                      required
                      hide-details="auto"
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      v-model="formData.message"
                      placeholder="How can we help..."
                      :rules="messageRules"
                      solo
                      flat
                      color="#f46523"
                      rows="4"
                      class="simple-input"
                      required
                      hide-details="auto"
                    ></v-textarea>
                  </v-col>

                  <v-col cols="12" class="mt-4">
                    <v-btn
                      :disabled="!valid"
                      x-large
                      block
                      color="#f46523"
                      dark
                      depressed
                      class="submit-btn gradient-btn"
                      @click="submitForm"
                    >
                      Send enquiry
                    </v-btn>
                  </v-col>

                  <v-col cols="12">
                    <p class="text-center response-time">
                      We'll get back to you in 1-2 business days.
                    </p>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
          <v-col cols="12" md="5">
            <div class="animate-slide-up delay-1">
              <v-card class="info-card mb-6" elevation="0">
                <h3 class="info-title mb-4">Contact Information</h3>

                <div class="info-item">
                  <div class="info-icon-wrapper">
                    <v-icon color="#f46523" size="24">mdi-map-marker</v-icon>
                  </div>
                  <div class="info-content">
                    <h4 class="info-label">Address</h4>
                    <p class="info-text">Bangalore, Karnataka, India</p>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-icon-wrapper">
                    <v-icon color="#f46523" size="24">mdi-phone</v-icon>
                  </div>
                  <div class="info-content">
                    <h4 class="info-label">Phone</h4>
                    <p class="info-text">+91 7034444303</p>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-icon-wrapper">
                    <v-icon color="#f46523" size="24">mdi-email</v-icon>
                  </div>
                  <div class="info-content">
                    <h4 class="info-label">Email</h4>
                    <p class="info-text">support@ohyesworld.com</p>
                  </div>
                </div>

                <div class="info-item">
                  <div class="info-icon-wrapper">
                    <v-icon color="#f46523" size="24">mdi-clock</v-icon>
                  </div>
                  <div class="info-content">
                    <h4 class="info-label">Working Hours</h4>
                    <p class="info-text">Mon - Sat: 9:00 AM - 7:00 PM</p>
                    <p class="info-text">Sunday: 10:00 AM - 5:00 PM</p>
                  </div>
                </div>
              </v-card>
              <v-card class="info-card" elevation="0">
                <h3 class="info-title mb-4">Follow Us</h3>
                <div class="social-links">
                  <v-btn icon large class="social-btn">
                    <v-icon color="#f46523">mdi-facebook</v-icon>
                  </v-btn>
                  <v-btn icon large class="social-btn">
                    <v-icon color="#f46523">mdi-twitter</v-icon>
                  </v-btn>
                  <v-btn icon large class="social-btn">
                    <v-icon color="#f46523">mdi-instagram</v-icon>
                  </v-btn>
                  <v-btn icon large class="social-btn">
                    <v-icon color="#f46523">mdi-linkedin</v-icon>
                  </v-btn>
                  <v-btn icon large class="social-btn">
                    <v-icon color="#f46523">mdi-whatsapp</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="4000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ContactPage",
  data() {
    return {
      valid: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      formData: {
        fullName: "",
        email: "",
        phone: "",
        company: "",
        subject: "",
        message: "",
      },
      subjects: [
        "General Inquiry",
        "Service Request",
        "Technical Support",
        "Billing Question",
        "Partnership Opportunity",
        "Complaint",
        "Feedback",
        "Other",
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 2) || "Name must be at least 2 characters",
      ],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) =>
          /^[0-9]{10}$/.test(v.replace(/\s/g, "")) ||
          "Phone number must be 10 digits",
      ],
      requiredRules: [(v) => !!v || "This field is required"],
      messageRules: [
        (v) => !!v || "Message is required",
        (v) =>
          (v && v.length >= 10) || "Message must be at least 10 characters",
      ],
    };
  },
  methods: {
    submitForm() {
      if (this.$refs.form.validate()) {
        console.log("Form submitted:", this.formData);

        this.snackbarText =
          "Message sent successfully! We'll get back to you soon.";
        this.snackbarColor = "success";
        this.snackbar = true;

        this.$refs.form.reset();
      } else {
        this.snackbarText = "Please fill in all required fields correctly.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
  },
};
</script>

<style scoped>
.contact-page {
  position: relative;
  min-height: 100vh;
  background: white;
  overflow: hidden;
}

.hero-gradient-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.05;
  z-index: 0;
  animation: bgPulse 20s ease-in-out infinite;
}

@keyframes bgPulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.05;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.08;
  }
}

.main-section {
  position: relative;
  z-index: 2;
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}

.contact-hero {
  text-align: center;
  padding: 60px 20px 40px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  background: rgba(244, 101, 35, 0.15);
  border: 1px solid rgba(244, 101, 35, 0.3);
  border-radius: 50px;
  color: black;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  backdrop-filter: blur(10px);
}

.contact-title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  letter-spacing: -1px;
  background: #f46523;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.contact-description {
  font-size: 1.1rem;
  color: black;
  line-height: 1.8;
  max-width: 700px;
  margin: 0 auto;
}

.contact-form-card,
.info-card {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 20px !important;
  padding: 40px 32px;
  backdrop-filter: blur(10px);
}

.form-title,
.info-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: black;
  margin-bottom: 24px;
}

/* Simple Input Styles */
::v-deep .simple-input .v-input__control {
  min-height: 56px !important;
}

::v-deep .simple-input.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f8f9fa !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  padding: 0 16px !important;
  box-shadow: none !important;
  min-height: 56px !important;
}

::v-deep .simple-input.v-textarea.v-text-field--solo .v-input__slot {
  padding: 16px !important;
  align-items: flex-start !important;
}

::v-deep .simple-input input,
::v-deep .simple-input textarea {
  color: #2c3e50 !important;
  font-size: 15px !important;
}

::v-deep .simple-input input::placeholder,
::v-deep .simple-input textarea::placeholder {
  color: #9e9e9e !important;
  opacity: 1 !important;
}

::v-deep .simple-input .v-select__selections {
  color: #2c3e50 !important;
}

::v-deep .simple-input .v-select__selection {
  color: #2c3e50 !important;
}

::v-deep
  .simple-input.v-text-field--solo:hover
  > .v-input__control
  > .v-input__slot {
  border-color: #f46523 !important;
}

::v-deep
  .simple-input.v-input--is-focused.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  border-color: #f46523 !important;
  border-width: 2px !important;
}

.submit-btn {
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 56px !important;
  font-size: 1rem !important;
}

.gradient-btn {
  background: #f46523 !important;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  z-index: 1 !important;
}

.gradient-btn:hover:not(:disabled) {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6) !important;
  transform: translateY(-2px) !important;
}

.gradient-btn:disabled {
  background: linear-gradient(135deg, #ef934c 0%, #ef934c 100%) !important;
  box-shadow: none !important;
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.response-time {
  color: #757575 !important;
  font-size: 14px !important;
  margin: 0 !important;
  padding-top: 4px !important;
}

.info-item {
  display: flex;
  gap: 16px;
  padding: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.info-item:last-child {
  border-bottom: none;
}

.info-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(244, 101, 35, 0.1);
  border: 2px solid rgba(244, 101, 35, 0.2);
  border-radius: 12px;
  flex-shrink: 0;
}

.info-content {
  flex: 1;
}

.info-label {
  font-size: 0.9rem;
  font-weight: 700;
  color: black;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.info-text {
  font-size: 1rem;
  color: black;
  line-height: 1.6;
  margin: 0;
}

.social-links {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.social-btn {
  background: rgba(244, 101, 35, 0.1) !important;
  border: 2px solid rgba(244, 101, 35, 0.2);
  transition: all 0.3s ease;
}

.social-btn:hover {
  background: rgba(244, 101, 35, 0.2) !important;
  border-color: #f46523 !important;
  transform: translateY(-4px);
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fade-in 0.8s ease forwards;
}

.animate-slide-up {
  animation: slide-up 0.8s ease forwards;
}

.delay-1 {
  animation-delay: 0.2s;
}

@media (max-width: 960px) {
  .contact-title {
    font-size: 2rem;
  }
  .contact-form-card,
  .info-card {
    padding: 32px 24px;
  }
}

@media (max-width: 600px) {
  .contact-hero {
    padding: 40px 16px 32px;
  }
  .contact-form-card,
  .info-card {
    padding: 24px 20px;
  }
  .form-title,
  .info-title {
    font-size: 1.5rem;
  }
}
</style>
